import { render, staticRenderFns } from "./advisor-button.vue?vue&type=template&id=894fac64&scoped=true&"
import script from "./advisor-button.vue?vue&type=script&lang=js&"
export * from "./advisor-button.vue?vue&type=script&lang=js&"
import style0 from "./advisor-button.vue?vue&type=style&index=0&id=894fac64&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "894fac64",
  null
  
)

export default component.exports